$(function() {
    // React when the logout link is clicked
    $('a#logout-link').click(function(event) {
        event.preventDefault();
        $(this).next('form').submit();
        return false;
    });

    // Autosize textareas that request it
    autosize($('textarea.autosize'));

    // Add a select2 dropdown automatically for simple replacements
    $('select.select2').select2();

    // Collect CSS files to use in our CKeditor
    var css = [];
    $('head').find('link[rel="stylesheet"][data-site]').each(function(idx, e) {
        css.push($(e).attr('href'));
    });

    // Automatically enable ckeditors that want to be replaced
    $('textarea.ckeditor-replace').ckeditor(function() {}, {
        contentsCss: css,
        //filebrowserBrowseUrl: ""
    });

    // See if we're in the admin area
    if ($('body').hasClass('admin-layout')) {
        // Left nav admin menu clicking
        $(document).off('click', 'body.admin-layout .sidebar-menu li a').on('click', 'body.admin-layout .sidebar-menu li a', function (e) {
            // How click the submenus open
            var animationSpeed = 300;

            //Get the clicked link and the next element
            var $this = $(this);
            var checkElement = $this.next();

            //Check if the next element is a menu and is visible
            if (checkElement.is('.treeview-menu') && checkElement.is(':visible') && !$('body').hasClass('sidebar-collapse')) {
                //Close the menu
                checkElement.slideUp(animationSpeed, function () {
                    checkElement.removeClass('menu-open');
                });
                checkElement.parent("li").removeClass("active");
            }

            //If the menu is not visible
            else if (checkElement.is('.treeview-menu') && !checkElement.is(':visible')) {
                //Get the parent menu
                var parent = $this.parents('ul').first();

                //Close all open menus within the parent
                var ul = parent.find('ul:visible').slideUp(animationSpeed);

                //Remove the menu-open class from the parent
                ul.removeClass('menu-open');

                //Get the parent li
                var parent_li = $this.parent("li");

                // Open the target menu and add the menu-open class
                checkElement.slideDown(animationSpeed, function () {
                    // Add the class active to the parent li
                    checkElement.addClass('menu-open');
                    parent.find('li.active').removeClass('active');
                    parent_li.addClass('active');
                });
            }

            //if this isn't a link, prevent the page from being redirected
            if (checkElement.is('.treeview-menu')) {
                e.preventDefault();
            }
        });

        //Enable sidebar toggle
        $(document).on('click', 'a.sidebar-toggle', function (e) {
            e.preventDefault();

            //Enable sidebar push menu
            if ($(window).width() > 767) {
                if ($("body").hasClass('sidebar-collapse')) {
                    $("body").removeClass('sidebar-collapse')/*.trigger('expanded.pushMenu')*/;
                } else {
                    $("body").addClass('sidebar-collapse')/*.trigger('collapsed.pushMenu')*/;
                }
            }
            //Handle sidebar push menu for small screens
            else {
                if ($("body").hasClass('sidebar-open')) {
                    $("body").removeClass('sidebar-open').removeClass('sidebar-collapse')/*.trigger('collapsed.pushMenu')*/;
                } else {
                    $("body").addClass('sidebar-open')/*.trigger('expanded.pushMenu')*/;
                }
            }
        });

        //Enable hide menu when clicking on the content-wrapper on small screens
        $("main").click(function () {
            if ($(window).width() <= 767 && $("body").hasClass("sidebar-open")) {
                $("body").removeClass('sidebar-open');
            }
        });

        // When the window is resized we need to adjust wrapper sizes
        $(window).resize(function() {
            // Get various element heights
            var headerHeight = $('header.main').outerHeight() || 0;
            var winHeight = $(window).height();
            var sidebarHeight = $(".sidebar").height() || 0;

            // Set the min-height of the content and sidebar based on the the height of the document.
            if (winHeight >= sidebarHeight) {
                $("main").css('min-height', winHeight - headerHeight);
            } else {
                $("main").css('min-height', sidebarHeight);
            }
        }).resize();
    }
});
